import { render, staticRenderFns } from "./honour.vue?vue&type=template&id=abc8affa&scoped=true&"
import script from "./honour.vue?vue&type=script&lang=js&"
export * from "./honour.vue?vue&type=script&lang=js&"
import style0 from "./honour.vue?vue&type=style&index=0&id=abc8affa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc8affa",
  null
  
)

export default component.exports